import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import Swal from 'sweetalert2'
import { getErrorsMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";
class ChangeEmail extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            email:'',
            password:'',
        };
        this.handleChangeEmail = this.handleChangeEmail.bind(this);
        this.handleChangePassword = this.handleChangePassword.bind(this);
    }

    handleChangeEmail(e){
        this.setState({ email:e.target.value})
    }

    handleChangePassword(e){
        this.setState({ password:e.target.value})
    }

    async componentDidMount() {
        const fv = FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                email: {
                    validators: {
                        notEmpty: {
                            message: 'Email requerido'
                        },
                        emailAddress: {
                            message: 'Email inválido'
                        }
                    },
                },
                password: {
                    validators: {
                        notEmpty: {
                            message: 'Contraseña requerida'
                        },
                        stringLength: {
                            min: 4,
                            max: 200,
                            message: 'La contraseña debe tener una longitud mínima de 4'
                        },
                    }
                },
                password_confirmation: {
                    validators: {
                        notEmpty: {
                            message: 'Contraseña requerida'
                        },
                        identical: {
                            compare: function() {
                                return KTUtil.getById('password').value;
                            },
                            message: 'Las contraseñas deben coincidir'
                        }
                    }
                },
                email_confirmation: {
                    validators: {
                        notEmpty: {
                            message: 'Correo requerido'
                        },
                        identical: {
                            compare: function() {
                                return KTUtil.getById('email').value;
                            },
                            message: 'los correos deben coincidir'
                        }
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        });

        const submitForm = document.getElementById('SubmitForm');
        submitForm.addEventListener('click', () => {
            fv.validate().then((status) => {
                if (status == 'Valid') {
                    let data = {
                        email:this.state.email,
                        password:this.state.password,
                        fiscal_name:this.props.fiscalName
                    }
                    window.blockUI();
                    axios.post('/api/users/set_temporary_email/'+this.props.userId,data).then(res=>{
                        window.unblockUI();
                        Swal.fire({
                            html: '<b>Confirmación de correo electrónico</b><br>Se ha enviado al correo <b>'+this.state.email+'</b> una contraseña temporal. <br/><br/>  Favor de accesar para confirmar contraseña.',
                            icon: "warning",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            }
                        }).then(function(result) {
                            location.reload()
                        });
                    }).catch(function (error) {
                        window.unblockUI();
                        Swal.fire({
                            text: getErrorsMessage(error),
                            icon: "error",
                            buttonsStyling: false,
                            confirmButtonText: "Aceptar",
                            customClass: {
                                confirmButton: "btn font-weight-bold btn-primary"
                            }
                        });
                    });
                }
            })
        })
    }

    render() {
        const { lang } = this.context; 
        return (
            <div className="modal fade " id="changeEmail" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">

            <div className="modal-dialog modal50 modal-dialog-centered modal-xl" role="document">

            <form id="frm">
                <div className="modal-content" style={{ background: '#f5f5f5' }}>
                <div class="modal-header">
                    <h5 class="modal-title">{lang.get('messages.actualizacion_de_correo_electronico')}</h5>
                </div>

                    <div className="modal-body px-15 py-10">
                        <div className="row">
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="text-alert">{lang.get('messages.nuevo_correo_electronico')}</label>
                                    <input name="email"
                                    id="email"
                                    autoComplete="false" value={this.state.email} onChange={this.handleChangeEmail} type="text" className="form-control form-control-lg form-control-solid" required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="text-alert">{lang.get('messages.confirma_nuevo_correo_electronico')}</label>
                                    <input name="email_confirmation"
                                    autoComplete="false"
                                    id="email_confirmation"
                                    type="text"
                                    onclick="emailShowHide('email_confirmation');"
                                    className="form-control form-control-lg form-control-solid"
                                    required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="text-alert">{lang.get('messages.ingresa_tu_contrasena_actual')}</label>
                                    <input name="password"
                                    onChange={this.handleChangePassword}
                                    id="password"
                                    type="password"
                                    autoComplete="new-password"
                                    className="form-control form-control-lg form-control-solid"
                                    required/>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="form-group">
                                    <label className="text-alert">{lang.get('messages.confirma_tu_contrasena')}</label>
                                    <input
                                    id="password_confirmation"
                                    onclick="passwordShowHide('password_confirmation');"
                                    name="password_confirmation"
                                    type="password"
                                    className="form-control form-control-lg form-control-solid" required/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" class="btn btn-secondary mr-4" data-dismiss="modal">{lang.get('messages.cancelar')}</button>
 
                        <button id="SubmitForm" type="button"   className="btn btn-primary">{lang.get('messages.actualizar_correo')}</button>
                    </div>
                </div>
                </form>
            </div>
        </div>
        );
    }
}

export default ChangeEmail;

if (document.getElementById('ChangeEmail')) {
    ReactDOM.render(<ChangeEmail />, document.getElementById('ChangeEmail'));
}
